import * as yup from "yup";

const feedback = yup.object().shape({
  detail: yup.string().required("Please enter your feedback"),
  stars: yup.string().required("Please submit overall rating"),
});

export { feedback };
